var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.3,332.2c-61.3,0-111.1-49.8-111.1-111.1c0-61.3,49.8-111.1,111.1-111.1c61.3,0,111.1,49.8,111.1,111.1 C334.4,282.4,284.6,332.2,223.3,332.2z M223.3,125.5c-52.7,0-95.6,42.9-95.6,95.6s42.9,95.6,95.6,95.6s95.6-42.9,95.6-95.6 S276,125.5,223.3,125.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,390c-2,0-4-0.8-5.5-2.3l-63.2-63.2c-3-3-3-8,0-11s8-3,11,0l63.2,63.2c3,3,3,8,0,11 C384,389.2,382,390,380,390z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3e41da74ed9774bd0c1656c73814b04b.svg";
export { ForwardRef as ReactComponent };